<app-main-content-card [wideContent]="true">
  <div
    class="title-bar baseline"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <button mat-button class="me-3" (click)="backButtonClicked()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h1>{{ "PRICING.TITLE" | translate }}</h1>
    </div>

    <button
      mat-raised-button
      color="primary"
      (click)="toInvalid.scrollToFirstInvalidControl(); onSave()"
      [disabled]="!modified"
    >
      {{ "SHARED.SAVE" | translate }}
    </button>
  </div>

  <div class="caption-row">
    <span class="head">
      {{ "PRICING.PRODUCT_PRICING_TABLE_HEADER.SITE_NAME" | translate }}
      <span class="net-price">({{ "NET_PRICE" | translate }})</span>
    </span>
    <span class="head">
      {{
        "PRICING.PRODUCT_PRICING_TABLE_HEADER.MANUFACTURER_OR_IMPORTER"
          | translate
      }}
      <span class="net-price">({{ "NET_PRICE" | translate }})</span>
    </span>
    <span class="head">
      {{ "PRICING.PRODUCT_PRICING_TABLE_HEADER.WHOLESALER" | translate }}
      <span class="net-price">({{ "NET_PRICE" | translate }})</span>
    </span>
    <span class="head">
      {{ "PRICING.PRODUCT_PRICING_TABLE_HEADER.RETAILER" | translate }}
      <span class="net-price">({{ "NET_PRICE" | translate }})</span>
    </span>
    <span class="head">
      {{ "PRICING.PRODUCT_PRICING_TABLE_HEADER.END_CONSUMER" | translate }}
      <span class="net-price">({{ "NET_PRICE" | translate }})</span>
    </span>
  </div>
  <div
    fxLayout="column"
    fxLayoutGap="15px"
    appScrollToInvalidControl
    #toInvalid="appScrollToInvalidControl"
    #pricingTable
  >
    <app-pricing-product-table
      *ngFor="let product of selectedProducts"
      [packagingUnitName]="product.packagingUnitName ?? ''"
      [label]="product.label ?? ''"
      [dataSource]="product.productSortimentEntries ?? []"
    ></app-pricing-product-table>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-raised-button
      color="primary"
      class="mt-4"
      (click)="toInvalid.scrollToFirstInvalidControl(); onSave()"
      [disabled]="!modified"
    >
      {{ "SHARED.SAVE" | translate }}
    </button>
  </div>
</app-main-content-card>
